import React from 'react';

import './MainCardImage.css';

const MainCardImage = ({
  size = 'regular',
  shape = 'rectangle',
  img,
  noImgMsg,
  alt = '',
}) => {
  const sizeClass = `main-card-img-${size}`;
  const shapeClass = `main-card-img-${shape}`;

  const containerClassNames = [
    'main-card-img-container',
    sizeClass,
    shapeClass,
  ].join(' ');

  const imgClassNames = ['main-card-img', sizeClass, shapeClass].join(' ');

  const noImgClassNames = [
    'main-card-no-picture-container',
    sizeClass,
    shapeClass,
  ].join(' ');

  return (
    <div className={containerClassNames}>
      {img ? (
        <img src={img} alt={alt} className={imgClassNames} />
      ) : (
        <div className={noImgClassNames}>
          <label className='main-card-no-picture-text' alt='No photo'>
            <span>{`No Photo\n ${noImgMsg || ''}`}</span>
          </label>
        </div>
      )}
    </div>
  );
};

export default MainCardImage;
